












import BaseComponent from '@/components/base-component.vue';
import UiAmbientIndicator from '@/components/UI/ambient-indicator.vue';
import UiDialog from '@/components/UI/dialog.vue';
import UiLoader from '@/components/UI/loader.vue';
import UiToast from '@/components/UI/toast.vue';
import { logout } from '@/services/auth';
import { checkToken } from '@/services/session-data';
import * as $Logout from '@/subjects/logout';
import moment from 'moment-timezone';
import Component from 'vue-class-component';
import BrowserValidate from './components/UI/browser-validate.vue';

@Component({
  components: {
    UiLoader,
    UiToast,
    UiDialog,
    UiAmbientIndicator,
    BrowserValidate
  },
})
export default class App extends BaseComponent {
  public beforeMount(): void {
    this.registerLogout();

    //this.checkTokenOnWindowFocus();
    
    this.prepareTimeZone();
  } 
   

  private checkTokenOnWindowFocus(): void {
    const checkTokenChange = checkToken();
    window.addEventListener(
      'focus',
      () => {
        checkTokenChange(() => this.$router.go(0));
      },
      false,
    );
  }

  private registerLogout(): void {
    $Logout.get().subscribe(() => {
      logout();

      this.$router.push('/login');
    });
  }

  private prepareTimeZone() {
    // https://github.com/moment/moment-timezone/blob/develop/data/packed/latest.json
    // https://momentjs.com/timezone/docs/#/data-loading/
    moment.tz.setDefault('America/Sao_Paulo');

    // Outro formato conforme doc:
    // https://github.com/eggert/tz/blob/2017b/etcetera#L36-L42
    // O GMT é positivo ao inves de negativo :/
    // moment.tz.setDefault('Etc/GMT+3');
  }

  
}
